import { useDispatch } from 'react-redux'

import configureStore from '../typedRedux/configureStoreWithHistory'

type AppDispatch = ReturnType<typeof configureStore>['store']['dispatch']

const useTypedDispatch = () => useDispatch<AppDispatch>()

export default useTypedDispatch
